import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Header } from './Header'
import { Footer } from './Footer'
import { CinematicCTA } from '@/components/sections/CinematicCTA'
import { ChatBot } from '@/components/ChatBot'
import { CookieBanner } from '@/components/CookieBanner'

const pagesWithoutCTA = ['contacts']

export function Layout() {
  const { t } = useTranslation()
  const location = useLocation()
  const currentSlug = location.pathname.split('/').filter(Boolean)[1] || ''
  const showCTA = !pagesWithoutCTA.includes(currentSlug)

  return (
    <>
      <a href="#main-content" className="skip-to-content">
        {t('aria.skipToContent')}
      </a>
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      {showCTA && <CinematicCTA />}
      <Footer />
      <ChatBot />
      <CookieBanner />
    </>
  )
}
